export enum SourceType {
  PointCloud = 'point_cloud',
  SurfaceModel = 'surface_model',
}

export enum SurfaceObject {
  Equipments = 'equipments',
  Vegetation = 'vegetation',
  Structures = 'structures',
  Other = 'other',
}
